import { makeGraphqlRequestCloud } from 'api/graphql/graphQLClient';
import { transformArrayToObject } from '@/utils/objectHelpers';
import DataNotFoundError from '@/errors/DataNotFoundError';
import { StandardFull } from '@/graphql/cloud/standards/queries/StandardFull.graphql';

export const apiStandards = {
  async getStandardFull(id) {
    const { standard: standardFull } = await makeGraphqlRequestCloud(StandardFull, { id });

    if (!standardFull) {
      throw new DataNotFoundError();
    }

    const { device, injections, column, method, ...standard } = standardFull;

    const [{ sequence_compound } = {}] = standard.sequence_compounds;

    return {
      device,
      injections: transformArrayToObject(
        injections.map(({ device, column, method, ...injection }) => {
          const getPeakData = () => {
            if (!injection.measurements || !Array.isArray(injection.measurements)) {
              return { peakArea: null, peakApexTimeStr: null };
            }

            const measurementWithCalibrationPoint = injection.measurements.find(
              (m) => m.calibration_points && m.calibration_points.length > 0,
            );

            if (!measurementWithCalibrationPoint) {
              return { peakArea: null, peakApexTimeStr: null };
            }

            const calibrationPoint = measurementWithCalibrationPoint.calibration_points[0];
            if (!calibrationPoint || !calibrationPoint.peak) {
              return { peakArea: null, peakApexTimeStr: null };
            }

            return {
              peakArea: calibrationPoint.peak.area,
              peakApexTimeStr: calibrationPoint.peak.apex_time_str,
            };
          };

          const { peakArea, peakApexTimeStr } = getPeakData();

          return {
            id: injection.id,
            device,
            column,
            method,
            injection: {
              ...injection,
              measurements: transformArrayToObject(injection.measurements, 'id'),
              peak_area: peakArea,
              peak_apex_time_str: peakApexTimeStr,
            },
          };
        }),
        'id',
      ),
      column,
      method,
      standard: {
        ...standard,
        sequence_compound,
        device_name: device?.name,
      },
    };
  },
};
